import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark, shadesOfPurple, dracula } from "@code-surfer/themes";
import { Box } from "..\\..\\..\\..\\slides\\src\\Box";
import { TimeLine } from "..\\..\\..\\..\\slides\\src\\TimeLine";
import { Spin } from "..\\..\\..\\..\\slides\\src\\Spin";
import { Layout } from "..\\..\\..\\..\\slides\\src\\Layout";
import { CSSCode } from "..\\..\\..\\..\\slides\\src\\CSSCode";
import { Term } from "..\\..\\..\\..\\slides\\src\\Components\\Term";
import OverviewFlow from "..\\..\\..\\..\\slides\\src\\Overview";
import * as React from 'react';
export default {
  CodeSurfer,
  CodeSurferColumns,
  Step,
  github,
  vsDark,
  shadesOfPurple,
  dracula,
  Box,
  TimeLine,
  Spin,
  Layout,
  CSSCode,
  Term,
  OverviewFlow,
  React
};